<template>
<div>
  <div class='employee-card'>
    <div class='employee-card-divider-header' />
    <div class='fl'>
      <div style='z-index: 1;'>
        <person-portrait :firstName="employee.initials" :lastName='employee.lastName' :scale="1"/>
      </div>
      <div style='margin-left: 22px;'>
        <h2 style='position: relative; top: -6px; font-size: 1.1em; letter-spacing: 0.2px;'>{{ employee.getFullName() }}</h2>

        <table class='mb-1 mt-4'>
          <tr>
            <td>
              <p class='label'>{{ 'employee.id-abrev' | translate }}</p>
              <p class='value'>{{ employee.employeeNumber }}</p>
            </td>
            <td>
              <p class='label'>{{ 'employee.date-of-birth' | translate }}</p>
              <p class='value'>{{ getFormattedDate(employee.dateOfBirth) }}</p>
            </td>
            <td colspan='2'>
              <p class='label'>{{ 'employee.gender' | translate }}</p>
              <p class='value'>{{ employee.gender | translate }}</p>
            </td>
          </tr>
          <tr>
            <td>
              <p class='label'>{{ 'report-of-sickness.first-of-absence' | translate }}</p>
              <p class='value'>{{ getFormattedDate(reportOfSickness.firstOfAbsence) }}</p>
            </td>
            <td>
              <p class='label'>{{ 'report-of-sickness.disability-rate-abrev' | translate }}</p>
              <p class='value'>{{ getLastDisabilityRate() }} %</p>
            </td>
            <td>
              <p class='label'>{{ 'report-of-sickness.safetynet' | translate }}</p>
              <p class='value'>{{ getSafetyNetText() }}</p>
            </td>
            <td>
              <p class='label'>{{ 'report-of-sickness.accident' | translate }}</p>
              <p class='value'>{{ getAccidentText() }}</p>
            </td>
            <td>
            </td>
          </tr>
        </table>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import Helpers from '@/shared/helpers/functions';
import Compositions from '@/views/helpers/compositions';
import PersonPortrait from '@aevitae/aevitaeui/0_atoms/containers/PersonPortrait.vue';
import { AccidentTypes } from '@/resources/models/reports-of-sickness';

export default {
  name: 'ReportOfSicknessCard',
  components: {
    PersonPortrait
  },
  props: {
    employee: Object,
    reportOfSickness: Object
  },
  methods: {
    getFormattedDate (date) {
      return Helpers.Dates.formatDate(date);
    },
    getSafetyNetText () {
      if (this.reportOfSickness.safetyNet === true) return this.$t('report-of-sickness.form.safety-net.true');
      else if (this.reportOfSickness.safetyNet === false) return this.$t('report-of-sickness.form.safety-net.false');
      else return this.$t('forms.no-entry');
    },
    getAccidentText () {
      switch (this.reportOfSickness.accidentType) {
        case AccidentTypes.None:
          return this.$t('report-of-sickness.form.accident-type.none');
        case AccidentTypes.ThirdPartyLiability:
          return this.$t('report-of-sickness.form.accident-type.third-party-liability');
        case AccidentTypes.NoThirdPartyLiability:
          return this.$t('report-of-sickness.form.accident-type.no-third-party-liability');
        default:
          return this.$t('forms.no-entry');
      }
    },
    getLastDisabilityRate () {
      return Compositions.getLatestDisabilityRateFromReportOfSickness(this.reportOfSickness);
    }
  }
};
</script>
<style lang="scss" scoped>
@import '@/assets/stylesheets/variables.scss';
.employee-card {
  padding: 20px 23px;
  position: relative;
  border: 1px solid $gray-lighten-1;
  border-radius: $border-radius;
  overflow: hidden;
}

.employee-card-divider-header {
  background-color: $gray-lighten-2;
  width: 100%;
  height: 53px;
  position: absolute;
  top: 0px;
  left: 0px;

}

.graph {
  z-index: 2 !important;
  border-radius: $border-radius;
  background-color: white;

  background-color: $gray-lighten-2;
  padding: 10px;
  height: 50px;
  width: 50px;
}

table {
  td{
    padding-right: 20px;
  }
  tr {
    &:first-child {
      td {
        padding-bottom: 10px;
      }
    }
  }
}
</style>
